import React from 'react';
import { EDULAI_PURPLE } from '../../styles/styleConsts';
import translations from '../../translations/i18next';
import { connect } from 'react-redux';
import { Html } from '../Html/Html';

const SubSkillDescription = ({ data }) => {
  if (!data) {
    return null;
  }
  return (
    <div style={{ marginLeft: 10 }}>
      <div>
        <h3 style={{ color: EDULAI_PURPLE }}>{translations.t(`skillsReport.strengths`)}</h3>
        <p style={{ fontSize: 15 }}>
          <Html>{data.strengths}</Html>
        </p>
      </div>
      <div>
        <h3 style={{ color: EDULAI_PURPLE }}>{translations.t(`skillsReport.weaknesses`)}</h3>
        <p style={{ fontSize: 15 }}>
          <Html>{data.mediumWeaknesses}</Html>
          <Html>{data.lowWeaknesses}</Html>
        </p>
      </div>
      {data.developmentArea && (
        <div>
          <h3 style={{ color: EDULAI_PURPLE }}>{translations.t(`skillsReport.areasDevelopments`)}</h3>
          <p style={{ fontSize: 15 }}>
            <Html>{data.developmentArea}</Html>
          </p>
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    lang: state.utils.selectedLanguage
  };
}

export default connect(mapStateToProps)(SubSkillDescription);
